import { createContext, useContext } from 'react';

import { PieChartInternalToolbarConfig } from '../types/toolbar.js';

export const ToolbarContext = createContext<
  PieChartInternalToolbarConfig | undefined
>(undefined);

export const useToolbarConfig = () => useContext(ToolbarContext);

ToolbarContext['displayName'] = 'ToolbarContext';
